<template>

  <div class="py-4 container-fluid">
    <div class="row">


      <div class="col-md-8">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Crear Producto</p>
              <argon-button v-if="(user.role != '1' && form.status == 0) || user.role == '1'" color="success"
                size="sm" class="ms-auto" @click="save">Guardar</argon-button>
              <argon-button v-if="form.id != 0 && ((user.role != '1' && form.status == 0) || (user.role == '1' && form.status == 0))"
                color="success" size="sm" class="" style="margin-left: 5px;" @click="confirm">Formalizar</argon-button>
            </div>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-sm">Información</p>
            <div class="row">
              <div class="col-md-12" style="position: relative;">
                <label for="example-text-input" class="form-control-label">Proveedor</label>
                <div class="d-flex gap-2">
                  <select ref="supplierSelect" class="form-select select2" style="width:100%;">
                  </select>
                  <argon-button color="success" size="sm" @click="openSupplierModal">
                    <i class="fa fa-user-plus"></i> 
                  </argon-button>
                </div>
              </div>
              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Telefono</label>
                <argon-input type="text" v-model="form.phone" :disabled="form.supplier_id > 0" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Email</label>
                <argon-input type="text" v-model="form.email" :disabled="form.supplier_id > 0" />
              </div>

              <div class="col-md-6">
                <label for="payment-type" class="form-control-label">Tipo de Pago</label>
                <select id="payment-type" class="form-select" v-model="form.payment_type">
                  <option value="contado">Contado</option>
                  <option value="credito">Crédito</option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="payment-method" class="form-control-label">Método de Pago</label>
                <select id="payment-method" class="form-select" v-model="form.payment_method">
                  <option value="">-- Sin especificar --</option>
                  <option value="EFECTIVO">EFECTIVO</option>
                  <option value="TRANSFERENCIA">TRANSFERENCIA</option>
                  <option value="TARJETA">TARJETA</option>
                  <option value="DATAFONO">DATAFONO</option>
                  <option value="CHEQUE">CHEQUE</option>
                </select>
              </div>

              <div class="col-md-6" v-if="form.payment_type === 'credito'">
                <label for="due-date" class="form-control-label">Fecha de Vencimiento</label>
                <input type="date" id="due-date" class="form-control" v-model="form.due_date" />
              </div>

              <div class="col-md-12">
                <label for="purchase-description" class="form-control-label">Descripción</label>
                <textarea
                  id="purchase-description"
                  class="form-control"
                  rows="3"
                  v-model="form.description"
                  placeholder="Escriba una descripción u observación de la compra"
                ></textarea>
              </div>

            </div>
          </div>
        </div>

        <div class="card" v-if="form.id != 0">

          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="text-uppercase mb-0">Lista de compras</p>
              <argon-button v-if="user.role == '1'" color="success" size="sm" class="ms-auto"
                @click="openModal">Agregar
                compra</argon-button>
              <argon-button v-if="user.role != '1' && form.status == 0" color="success" size="sm" class="ms-auto"
                @click="openModal">Agregar compra</argon-button>
            </div>
          </div>

          <div class="card-body">
            <div class="row">

              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Producto</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Cantidad (Und - Mts)</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Costo
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">IVA
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha
                      </th>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center"
                        v-if="(user.role != '1' && form.status == 0) || user.role == '1'">
                        Opciones
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="value in data.data" :key="value.id">
                      <td>
                        <div class="d-flex px-2 py-1">
                          <div class="d-flex flex-column justify-content-center">
                            <h6 class="mb-0 text-sm">{{ value.inventory.name }}</h6>
                            <span v-if="value.variant" class="text-xs text-secondary">
                              {{ [value.variant.size?.size, value.variant.color?.name].filter(Boolean).join(' - ') || value.variant.title || 'Variante' }}
                            </span>
                            <span v-if="value.bodega" class="text-xs text-info">
                              <i class="fa fa-warehouse"></i> {{ value.bodega.name }}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <input
                          type="number"
                          min="1"
                          step="1"
                          class="form-control form-control-sm text-center"
                          style="width: 80px; margin: 0 auto;"
                          :value="value.quantity"
                          @change="onDetailQuantityChange($event, value)"
                        />
                      </td>
                      <td class="align-middle text-center text-sm">
                        {{ parseFloat(value.price).toLocaleString('es-ES', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }) }}
                      </td>
                      <td class="align-middle text-center text-sm">
                        {{ parseFloat(value.iva || 0).toLocaleString('es-ES', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }) }}%
                      </td>
                      <td class="align-middle text-center text-sm">
                        {{ (parseFloat(value.total_price) || 0).toLocaleString('es-ES', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }) }}
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ new Date(value.updated_at).toLocaleDateString('es-ES') }}
                        </span>
                      </td>

                      <td class="align-middle text-center"
                        v-if="(user.role != '1' && form.status == 0) || user.role == '1'">

                        <!-- Editar -->
                        <a @click="editRegister(value)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                          data-toggle="tooltip" data-original-title="Editar registro">
                          <i class="fa fa-pencil-alt"></i>
                        </a>

                        <a @click="deleteRegister(value.id)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                          style="margin-left: 15px;" data-original-title="Eliminar registro">
                          <i class="fa fa-trash"></i>
                        </a>

                      </td>
                    </tr>

                    <!-- No hay registros -->
                    <tr v-if="!data?.data || data.data.length==0" >
                      <td colspan="6" class="text-center text-secondary text-sm">
                        No hay registros
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Tarjeta de Pagos/Abonos -->
        <div class="card mb-2 mt-2" v-if="form.id != 0">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="text-uppercase mb-0">Pagos y Abonos</p>
              <argon-button v-if="(user.role != '1' && form.status == 0) || user.role == '1'" color="success" size="sm" class="ms-auto"
                @click="openPaymentModal">Agregar Pago</argon-button>
            </div>
          </div>
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4">
                <p class="mb-0 text-sm"><strong>Total Compra:</strong> 
                  {{ formatCurrency(purchaseTotal) }}
                </p>
              </div>
              <div class="col-md-4">
                <p class="mb-0 text-sm"><strong>Total Pagado:</strong> 
                  <span :class="totalPaid >= purchaseTotal ? 'text-success' : ''">
                    {{ formatCurrency(totalPaid) }}
                  </span>
                </p>
              </div>
              <div class="col-md-4">
                <p class="mb-0 text-sm"><strong>Pendiente:</strong> 
                  <span :class="pendingAmount > 0 ? 'text-danger' : 'text-success'">
                    {{ formatCurrency(pendingAmount) }}
                  </span>
                </p>
              </div>
            </div>
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Método</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Monto</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Observación</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center"
                      v-if="(user.role != '1' && form.status == 0) || user.role == '1'">
                      Opciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="payment in payments" :key="payment.id">
                    <td>
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ formatDate(payment.payment_date) }}
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span v-if="payment.payment_method" class="badge badge-sm bg-gradient-info">{{ payment.payment_method }}</span>
                      <span v-else class="text-muted text-xs">—</span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ formatCurrency(payment.amount) }}
                    </td>
                    <td>
                      <span class="text-secondary text-xs">
                        {{ payment.observation || '-' }}
                      </span>
                    </td>
                    <td class="align-middle text-center"
                      v-if="(user.role != '1' && form.status == 0) || user.role == '1'">
                      <a @click="editPayment(payment)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                        data-toggle="tooltip" data-original-title="Editar pago">
                        <i class="fa fa-pencil-alt"></i>
                      </a>
                      <a @click="deletePayment(payment.id)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                        style="margin-left: 15px;" data-original-title="Eliminar pago">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>
                  <tr v-if="!payments || payments.length === 0">
                    <td colspan="5" class="text-center text-secondary text-sm">
                      No hay pagos registrados
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Columna lateral para documentos -->
      <div class="col-md-4" v-if="form.id != 0">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Documentos de Compra</p>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Seleccionar archivo (Imagen o PDF)</label>
                <input
                  class="form-control"
                  type="file"
                  id="fileDocumento"
                  accept="image/*,.pdf"
                  @change="saveDocumento"
                />
              </div>
            </div>

            <div v-if="documentos.length > 0" class="list-group mt-3">
              <div
                v-for="(documento, index) in documentos"
                :key="documento.id"
                class="list-group-item d-flex justify-content-between align-items-center mt-1"
              >
                <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: inline-block; text-align: center;">
                  <div v-if="index === 0 && isImage(documento.file_path)" class="text-center mb-2">
                    <img :src="apiUrl + documento.file_path" alt="Documento" class="img-fluid mb-2 w-100">
                  </div>
                  <i :class="getFileIcon(documento.file_path)" class="me-2"></i>
                  {{ documento.file_name }}
                </span>

                <div style="align-items: center; display: flex;">
                  <a
                    v-if="index > 0 || !isImage(documento.file_path)"
                    color="info"
                    size="sm"
                    @click="viewDocument(documento.file_path)"
                    class="text-secondary font-weight-bold text-xs cursor-pointer"
                    data-toggle="tooltip"
                    data-original-title="Ver documento"
                  >
                    <i class="fas fa-eye"></i>
                  </a>

                  <a
                    @click="deleteMedia(documento.id)"
                    class="text-secondary font-weight-bold text-xs cursor-pointer"
                    style="margin-left: 5px;"
                    data-toggle="tooltip"
                    data-original-title="Eliminar registro"
                  >
                    <i class="fa fa-trash"></i>
                  </a>
                </div>
              </div>
            </div>
            <p v-else class="text-center mt-2">No hay documentos disponibles.</p>
          </div>
        </div>
      </div>

    </div>

    <!-- Modal Agregar Proveedor -->
    <div class="modal fade" id="ModalSupplier" tabindex="-1" aria-labelledby="supplierModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="supplierModalLabel">Agregar Proveedor</h5>
            <button type="button" class="btn-close" @click="closeSupplierModal"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="mb-3">
                <label for="supplier-name" class="form-label">Nombre</label>
                <input type="text" v-model="newSupplier.name" id="supplier-name" class="form-control"
                  placeholder="Ingrese el nombre del proveedor" required>
              </div>
              <div class="mb-3">
                <label for="supplier-document-type" class="form-label">Tipo de Documento</label>
                <select id="supplier-document-type" class="form-select" v-model="newSupplier.document_type">
                  <option value="" disabled>Seleccione un tipo de documento</option>
                  <option value="CC">Cédula de Ciudadanía (CC)</option>
                  <option value="CE">Cédula de Extranjería (CE)</option>
                  <option value="TI">Tarjeta de Identidad (TI)</option>
                  <option value="RC">Registro Civil (RC)</option>
                  <option value="PA">Pasaporte (PA)</option>
                  <option value="PEP">Permiso Especial de Permanencia (PEP)</option>
                  <option value="NIT">Número de Identificación Tributaria (NIT)</option>
                </select>
              </div>
              <div class="mb-3">
                <label for="supplier-document" class="form-label">Número de Documento</label>
                <input type="text" v-model="newSupplier.document" id="supplier-document" class="form-control"
                  placeholder="Ingrese el número de documento" required>
              </div>
              <div class="mb-3">
                <label for="supplier-address" class="form-label">Dirección</label>
                <input type="text" v-model="newSupplier.address" id="supplier-address" class="form-control"
                  placeholder="Ingrese la dirección">
              </div>
              <div class="mb-3">
                <label for="supplier-phone" class="form-label">Teléfono</label>
                <input type="text" v-model="newSupplier.phone" id="supplier-phone" class="form-control"
                  placeholder="Ingrese el teléfono" required>
              </div>
              <div class="mb-3">
                <label for="supplier-email" class="form-label">Email</label>
                <input type="email" v-model="newSupplier.email" id="supplier-email" class="form-control"
                  placeholder="Ingrese el email" required>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeSupplierModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="saveSupplier">Guardar Proveedor</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Agregar/Editar Pago -->
    <div class="modal fade" id="ModalPayment" tabindex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="paymentModalLabel">{{ paymentForm.id ? 'Editar Pago' : 'Agregar Pago' }}</h5>
            <button type="button" class="btn-close" @click="closePaymentModal"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="mb-3">
                <label for="payment-method-select" class="form-label">Método de Pago</label>
                <select v-model="paymentForm.payment_method" id="payment-method-select" class="form-select">
                  <option value="EFECTIVO">EFECTIVO</option>
                  <option value="TRANSFERENCIA">TRANSFERENCIA</option>
                  <option value="TARJETA">TARJETA</option>
                  <option value="DATAFONO">DATAFONO</option>
                  <option value="NEQUI">NEQUI</option>
                  <option value="BANCOLOMBIA AHORROS">BANCOLOMBIA AHORROS</option>
                  <option value="BANCOLOMBIA SAS">BANCOLOMBIA SAS</option>
                  <option value="DAVIPLATA">DAVIPLATA</option>
                  <option value="CHEQUE">CHEQUE</option>
                </select>
              </div>
              <div class="mb-3">
                <label for="payment-amount" class="form-label">Monto</label>
                <input type="number" step="0.01" v-model.number="paymentForm.amount" id="payment-amount" class="form-control"
                  placeholder="Ingrese el monto del pago" required>
              </div>
              <div class="mb-3">
                <label for="payment-date" class="form-label">Fecha del Pago</label>
                <input type="date" v-model="paymentForm.payment_date" id="payment-date" class="form-control" required>
              </div>
              <div class="mb-3">
                <label for="payment-observation" class="form-label">Observación</label>
                <textarea v-model="paymentForm.observation" id="payment-observation" class="form-control"
                  placeholder="Ingrese una observación (opcional)" rows="3"></textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closePaymentModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="savePayment">Guardar Pago</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Asignar tecnico -->
    <div class="modal fade" id="ModalBudget" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Agregar compra</h5>
            <button type="button" class="btn-close" @click="closeModal"></button>
          </div>
          <div class="modal-body">
            <!-- Buscador -->
            <div class="mb-3">
              <input
                type="text"
                v-model="productSearch"
                class="form-control"
                placeholder="Buscar producto..."
              />
            </div>

            <!-- Grid de productos -->
            <div v-if="loadingProducts" class="text-center py-4">
              <i class="fas fa-spinner fa-spin fa-2x text-success"></i>
            </div>
            <div v-else class="pur-product-grid">
              <button
                v-for="prod in filteredProducts"
                :key="prod.id"
                type="button"
                class="pur-product-card"
                @click="onProductClick(prod)"
              >
                <div class="pur-product-image mb-2 text-center">
                  <img
                    v-if="prod.image_url"
                    :src="prod.image_url"
                    :alt="prod.name"
                    style="width: 100%; max-height: 80px; object-fit: cover; border-radius: 6px;"
                    loading="lazy"
                  />
                  <i v-else class="fas fa-box-open text-secondary fa-2x"></i>
                </div>
                <div class="pur-product-info">
                  <h6 class="mb-0 text-sm">{{ prod.name || 'Sin nombre' }}</h6>
                  <p class="mb-0 text-xs text-secondary">Ref: {{ prod.ref || '—' }}</p>
                  <p class="mb-0 text-xs" :class="(prod.quantity > 0 || !prod.manage_stock) ? 'text-success' : 'text-danger'">
                    Stock: {{ prod.manage_stock ? (prod.quantity || 0) : 'N/A' }}
                  </p>
                  <span class="badge badge-sm bg-gradient-success">{{ formatCurrency(prod.sale_price) }}</span>
                  <span v-if="prod.has_variants" class="badge badge-sm bg-gradient-info ms-1">Variantes</span>
                </div>
              </button>
            </div>
            <div v-if="!loadingProducts && filteredProducts.length === 0" class="text-center text-muted py-3">
              No hay productos disponibles
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal seleccionar variante (estilo POS) -->
    <div v-if="showVariantModal" class="pur-variant-overlay" @click.self="cancelVariantModal">
      <div class="pur-variant-box card shadow">
        <div class="card-body">
          <h6 class="mb-1">Seleccionar variante</h6>
          <p v-if="pendingProduct" class="text-sm text-muted mb-3">
            <strong>{{ pendingProduct.name }}</strong>
          </p>
          <div class="mb-3">
            <label class="form-control-label text-xs">Bodega (destino del stock)</label>
            <select class="form-select form-select-sm" v-model="selectedBodegaId">
              <option :value="null" disabled>Seleccionar bodega</option>
              <option v-for="b in bodegas" :key="b.id" :value="b.id">{{ b.name }}</option>
            </select>
          </div>
          <div class="pur-variant-list" v-if="pendingProduct && pendingProduct.variants && pendingProduct.variants.length > 0">
            <button
              v-for="v in pendingProduct.variants"
              :key="v.id"
              type="button"
              class="pur-variant-btn"
              :class="{ 'pur-variant-btn--selected': selectedVariantId === v.id }"
              @click="selectedVariantId = v.id"
            >
              <span class="pur-variant-title">{{ v.title }}</span>
              <span class="pur-variant-meta">
                <span :class="v.inventory_quantity > 0 ? 'text-success' : 'text-danger'">
                  Stock: {{ v.inventory_quantity }}
                </span>
                &nbsp;·&nbsp;
                <strong>{{ formatCurrency(v.price) }}</strong>
              </span>
            </button>
          </div>
          <div class="d-flex gap-2 justify-content-end mt-3">
            <button type="button" class="btn btn-secondary btn-sm" @click="cancelVariantModal">Cancelar</button>
            <button type="button" class="btn btn-success btn-sm" :disabled="!selectedBodegaId || (pendingProduct && pendingProduct.variants && pendingProduct.variants.length > 0 && !selectedVariantId)" @click="confirmVariant">Agregar a lista de compras</button>
          </div>
        </div>
      </div>
    </div>
  </div>



</template>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
//import ArgonTextarea from "../../../components/ArgonTextarea.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';
import { Modal } from 'bootstrap';
import posService from '../../../services/pos.service';
import bodegasService from '../../../services/bodegas.service';

const body = document.getElementsByTagName("body")[0];

export default {
  name: "Models Create",
  data() {
    return {
      showMenu: false,
      modalBudget: null,
      isFinish: false,
      user: {},
      form: {
        id: 0,
        supplier: '',
        supplier_id: 0,
        phone: '',
        email: '',
        status: 0,
        payment_type: 'contado',
        payment_method: '',
        due_date: null,
        description: '',
      },
      size: {
        size: '',
        color_id: '',
        model_id: '',
        quantity: 0,
        status: 1
      },
      insumos: [],
      colors: [],
      sizes: [],
      purchases: [],
      purchase: {
        id: 0,
        purchase_id: 0,
        inventory_id: 0,
        quantity: 0,
        price: 0,
        iva: 0,
        total_price: 0,
      },
      data: {},
      modal: {
        id: 0,
        user_id: null,
        project_id: null,
        amount: "",
        status: "active"
      },
      modalEvidencia: [],
      suppliers: [],
      filteredSuppliers: [],
      supplierModal: null,
      newSupplier: {
        id: 0,
        name: '',
        document_type: '',
        document: '',
        address: '',
        phone: '',
        email: '',
        role: '5', // Proveedor
        status: '1',
        password: 'proveedor123',
        password_confirmation: 'proveedor123',
        payment: '0',
        processes: [],
      },
      payments: [],
      paymentModal: null,
      paymentForm: {
        id: 0,
        purchase_id: 0,
        amount: 0,
        payment_method: '',
        payment_date: new Date().toISOString().split('T')[0],
        observation: '',
      },
      documentos: [],
      apiUrl: process.env.VUE_APP_API_IMAGE_URL,
      productSearch: '',
      loadingProducts: false,
      showVariantModal: false,
      pendingProduct: null,
      selectedVariantId: null,
      selectedBodegaId: null,
      bodegas: [],
      products: [],
    };
  },
  components: { ArgonInput, ArgonButton },
  computed: {
    formattedPrice: {
      get() {
        const price = this.purchase.price || 0;
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        const numericValue = parseInt(value.replace(/\./g, "") || 0);
        this.purchase.price = numericValue;
        this.updateTotal();
      },
    },
    totalPrice: {
      get() {
        const total = this.purchase.total_price || 0;
        return total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        this.purchase.total_price = Math.floor(value.replace(/\./g, "") || 0);
        const quantity = parseFloat(this.purchase.quantity) || 0;
        const ivaRate = (parseFloat(this.purchase.iva) || 0) / 100;
        const divisor = quantity > 0 ? (quantity * (1 + ivaRate)) : 0;
        this.purchase.price = divisor > 0 ? Math.floor(this.purchase.total_price / divisor) : 0;
      },
    },
    purchaseTotal() {
      if (!this.data || !this.data.data) return 0;
      return this.data.data.reduce((sum, item) => sum + (parseFloat(item.total_price) || 0), 0);
    },
    totalPaid() {
      return this.payments.reduce((sum, payment) => sum + (parseFloat(payment.amount) || 0), 0);
    },
    pendingAmount() {
      return this.purchaseTotal - this.totalPaid;
    },
    filteredProducts() {
      if (!this.productSearch) return this.products;
      const q = this.productSearch.toLowerCase();
      return this.products.filter((prod) => {
        const name = (prod.name || '').toLowerCase();
        const ref = (prod.ref || '').toLowerCase();
        const barcode = (prod.barcode || '').toLowerCase();
        return name.includes(q) || ref.includes(q) || barcode.includes(q);
      });
    },
  },
  methods: {
    async loadBodegas() {
      try {
        const res = await bodegasService.getPaginated({ page: 1, per_page: 1000 });
        const d = res.data;
        this.bodegas = (d && d.data) ? d.data : (Array.isArray(d) ? d : []);
      } catch (e) {
        console.error('Error al cargar bodegas:', e);
      }
    },
    async getSuppluers() {
      try {
        // Obtener todos los usuarios con role 5 (proveedores)
        const response = await this.$store.dispatch('users/getAll');
        let users = [];
        
        // El backend devuelve directamente un array cuando page=all
        if (Array.isArray(response)) {
          users = response;
        } else if (response && response.data) {
          // Si viene con estructura de respuesta
          if (Array.isArray(response.data)) {
            users = response.data;
          } else if (response.data.data && Array.isArray(response.data.data)) {
            users = response.data.data;
          }
        }
        
        // Filtrar solo proveedores (role == '5')
        this.suppliers = users.filter(user => user.role == '5');
        
        this.$nextTick(() => {
          const select = $(this.$refs.supplierSelect);

          // Si Select2 ya está inicializado, refrescar las opciones y mantener selección
          if (select.hasClass("select2-hidden-accessible")) {
            // Guardar selección actual
            const currentVal = select.val();

            // Destruir y reconstruir para que incluya las nuevas opciones
            select.off('change');
            select.select2('destroy');
            select.empty();
            select.append('<option value="" disabled selected>Seleccionar proveedor</option>');

            this.suppliers.forEach(supplier => {
              const displayText = `${supplier.name} - ${supplier.email || supplier.phone || ''}`;
              select.append(new Option(displayText, supplier.id, false, false));
            });

            select.select2({
              placeholder: 'Seleccione un proveedor',
              allowClear: true,
            }).on('change', () => {
              const selectedId = select.val();
              if (selectedId) {
                const selectedSupplier = this.suppliers.find(s => s.id == selectedId);
                if (selectedSupplier) {
                  this.form.supplier_id = selectedSupplier.id;
                  this.form.supplier = selectedSupplier.name;
                  this.form.email = selectedSupplier.email || '';
                  this.form.phone = selectedSupplier.phone || '';
                }
              } else {
                this.form.supplier_id = 0;
                this.form.supplier = '';
                this.form.email = '';
                this.form.phone = '';
              }
            });

            // Restaurar selección previa si sigue existiendo
            if (currentVal && this.suppliers.find(s => s.id == currentVal)) {
              select.val(currentVal).trigger('change');
            }
            return;
          }

          select.empty();
          select.append('<option value="" disabled selected>Seleccionar proveedor</option>');
          
          this.suppliers.forEach(supplier => {
            const displayText = `${supplier.name} - ${supplier.email || supplier.phone || ''}`;
            select.append(new Option(displayText, supplier.id, false, false));
          });
          
          select.select2({
            placeholder: 'Seleccione un proveedor',
            allowClear: true,
          }).on('change', () => {
            const selectedId = select.val();
            if (selectedId) {
              const selectedSupplier = this.suppliers.find(s => s.id == selectedId);
              if (selectedSupplier) {
                this.form.supplier_id = selectedSupplier.id;
                this.form.supplier = selectedSupplier.name;
                this.form.email = selectedSupplier.email || '';
                this.form.phone = selectedSupplier.phone || '';
              }
            } else {
              this.form.supplier_id = 0;
              this.form.supplier = '';
              this.form.email = '';
              this.form.phone = '';
            }
          });
          
          // Si hay un proveedor seleccionado, establecerlo
          if (this.form.supplier_id > 0) {
            select.val(this.form.supplier_id).trigger('change');
          }
        });
      } catch (error) {
        console.error('Error al obtener proveedores:', error);
      }
    },
    openSupplierModal() {
      // Resetear el formulario del nuevo proveedor
      this.newSupplier = {
        id: 0,
        name: '',
        document_type: '',
        document: '',
        address: '',
        phone: '',
        email: '',
        role: '5',
        status: '1',
        password: 'proveedor123',
        password_confirmation: 'proveedor123',
        payment: '0',
        processes: [],
      };
      
      const modalElement = document.getElementById('ModalSupplier');
      this.supplierModal = new Modal(modalElement);
      this.supplierModal.show();
    },
    closeSupplierModal() {
      if (this.supplierModal) {
        this.supplierModal.hide();
      }
    },
    async saveSupplier() {
      try {
        // Validar campos requeridos
        if (!this.newSupplier.name || !this.newSupplier.email || !this.newSupplier.phone) {
          await Swal.fire({
            icon: 'warning',
            title: 'Campos requeridos',
            text: 'Por favor complete todos los campos obligatorios.',
            confirmButtonText: 'Aceptar'
          });
          return;
        }
        
        // Crear el proveedor en usuarios
        const response = await this.$store.dispatch('users/save', this.newSupplier);
        
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El proveedor ha sido registrado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          });
          
          // Recargar la lista de proveedores
          await this.getSuppluers();

          // Seleccionar el nuevo proveedor
          const newSupplierId = response.data?.id || response.id;
          this.$nextTick(() => {
            const select = $(this.$refs.supplierSelect);
            if (newSupplierId) {
              select.val(newSupplierId).trigger('change');
            }
          });
          
          this.closeSupplierModal();
        } else {
          throw new Error(response.data?.message || 'Error al guardar el proveedor');
        }
      } catch (error) {
        console.error("Error al crear el proveedor:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al guardar el proveedor',
        });
      }
    },
    getIconClass(status) {
      if (status === 0) {
        return 'fa fa-circle'; // Ícono de clic
      } else if (status === 1) {
        return 'fa fa-check-circle text-success'; // Ícono de check verde
      } else if (status === 2) {
        return 'fa fa-times-circle text-danger'; // Ícono de X roja
      }
      return ''; // Devuelve una cadena vacía si no coincide con ningún estado
    },
    openModal() {
      this.productSearch = '';
      this.showVariantModal = false;
      this.pendingProduct = null;
      this.selectedVariantId = null;
      this.loadProducts();
      const modalElement = document.getElementById('ModalBudget');
      this.modalBudget = new Modal(modalElement);
      this.modalBudget.show();
    },
    closeModal() {
      this.showVariantModal = false;
      this.pendingProduct = null;
      this.selectedVariantId = null;
      this.productSearch = '';
      if (this.modalBudget) {
        this.modalBudget.hide();
      }
    },
    async loadProducts() {
      this.loadingProducts = true;
      try {
        const res = await posService.getProducts({ page: 1, per_page: 1000 });
        const d = res.data;
        this.products = d.data || [];
      } catch (error) {
        console.error('Error al cargar productos:', error);
      } finally {
        this.loadingProducts = false;
      }
    },
    onProductClick(prod) {
      if (this.modalBudget) {
        this.modalBudget.hide();
      }
      this.$nextTick(() => {
        this.pendingProduct = prod;
        this.selectedVariantId = null;
        this.selectedBodegaId = null;
        this.showVariantModal = true;
      });
    },
    cancelVariantModal() {
      this.showVariantModal = false;
      this.pendingProduct = null;
      this.selectedVariantId = null;
      this.selectedBodegaId = null;
    },
    confirmVariant() {
      if (!this.pendingProduct || !this.selectedBodegaId) return;
      const prod = this.pendingProduct;
      const bodegaId = this.selectedBodegaId;
      const variant = this.selectedVariantId
        ? prod.variants.find((v) => v.id === this.selectedVariantId)
        : null;
      this.cancelVariantModal();
      this.addDirectToDetail(prod, variant, bodegaId);
    },
    async addDirectToDetail(prod, variant, bodegaId = null) {
      const payload = {
        id: 0,
        purchase_id: this.form.id,
        inventory_id: prod.id,
        variant_id: variant ? variant.id : null,
        bodega_id: bodegaId,
        quantity: 1,
        price: variant ? parseFloat(variant.price || 0) : parseFloat(prod.sale_price || 0),
        iva: 0,
      };

      try {
        const response = await this.$store.dispatch('purchasesDetails/save', payload);
        if (response && response.status >= 200 && response.status < 300) {
          this.productSearch = '';
          this.getData();
          this.closeModal();
        } else {
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: response?.data?.message || 'No se pudo agregar el producto.',
          });
        }
      } catch (error) {
        console.error('Error al agregar producto:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || 'No se pudo agregar el producto.',
        });
      }
    },
    async onDetailQuantityChange(event, value) {
      const input = event.target;
      const newQty = parseInt(input.value, 10);
      const currentQty = parseInt(value.quantity, 10);
      if (isNaN(newQty) || newQty < 1) {
        input.value = currentQty;
        return;
      }
      if (newQty === currentQty) return;

      const detailId = value.id;
      const purchaseId = value.purchase_id;
      const inventoryId = value.inventory_id;
      const variantId = value.variant_id || null;
      const bodegaId = value.bodega_id || null;
      const price = parseFloat(value.price) || 0;
      const iva = parseFloat(value.iva) || 0;

      let response;
      try {
        response = await this.$store.dispatch('purchasesDetails/save', {
          id: detailId,
          purchase_id: purchaseId,
          inventory_id: inventoryId,
          variant_id: variantId,
          bodega_id: bodegaId,
          quantity: newQty,
          price,
          iva,
        });
      } catch (error) {
        console.error('Error al actualizar cantidad:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || 'No se pudo actualizar la cantidad.',
        });
        input.value = currentQty;
        return;
      }

      if (response && response.status >= 200 && response.status < 300) {
        this.getData();
      } else {
        input.value = currentQty;
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: response?.data?.message || 'No se pudo actualizar la cantidad.',
        });
      }
    },
    async getData() {
      await this.$store.dispatch('purchasesDetails/getData', this.form.id);
      this.data = this.$store.state.purchasesDetails.getData;

      console.log(this.data);
      
      // Cargar pagos y documentos cuando se cargan los datos
      await this.getPayments();
      await this.getDocumentos();
    },
    async getInsumos() {
      this.insumos = await this.$store.dispatch('inventory/getAll');
    },
    async confirm() {

      await Swal.fire({
        icon: 'info',
        title: 'Formalizar compra',
        text: 'Al formalizar la compra ya no se podra editar los registros ni los detalles de la compra',
        confirmButtonText: 'Aceptar',
        backdrop: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.form.status = 1;
          this.save();
        }
      });
    },
    async save() {
      try {
        // Si hay un proveedor seleccionado pero no existe en usuarios, crearlo
        if (this.form.supplier && this.form.supplier_id == 0) {
          // Verificar si el proveedor ya existe por email o nombre
          const existingSupplier = this.suppliers.find(s => 
            s.email === this.form.email || s.name === this.form.supplier
          );
          
          if (!existingSupplier && this.form.email && this.form.supplier) {
            // Crear el proveedor en usuarios
            const supplierData = {
              id: 0,
              name: this.form.supplier,
              email: this.form.email,
              phone: this.form.phone || '',
              address: '',
              document_type: 'NIT',
              document: '',
              role: '5', // Proveedor
              status: '1',
              password: 'proveedor123',
              password_confirmation: 'proveedor123',
              payment: '0',
              processes: [],
            };
            
            const supplierResponse = await this.$store.dispatch('users/save', supplierData);
            
            if (supplierResponse && supplierResponse.status >= 200 && supplierResponse.status < 300) {
              this.form.supplier_id = supplierResponse.data.id;
              // Recargar la lista de proveedores
              await this.getSuppluers();
            }
          } else if (existingSupplier) {
            this.form.supplier_id = existingSupplier.id;
          }
        }
        
        // Dispara la acción de Vuex para guardar la compra
        const response = await this.$store.dispatch("purchases/save", this.form);
        if (response && response.status >= 200 && response.status < 300) {
          const result = await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          });

          if (result.isConfirmed) {
            this.form.id = parseInt(response.data.id) || 0;
            this.form.supplier = response.data.supplier || '';
            this.form.supplier_id = parseInt(response.data.supplier_id) || 0;
            this.form.phone = response.data.phone || '';
            this.form.email = response.data.email || '';
            this.form.status = parseInt(response.data.status) || 0;
            this.form.payment_type = response.data.payment_type || 'contado';
            this.form.payment_method = response.data.payment_method || '';
            this.form.due_date = response.data.due_date || null;
            this.form.description = response.data.description || '';

            this.purchase.purchase_id = parseInt(response.data.id) || 0;
            
            // Recargar proveedores para seleccionar el correcto
            await this.getSuppluers();
            
            // Cargar pagos y documentos si existe la compra
            if (this.form.id > 0) {
              await this.getPayments();
              await this.getDocumentos();
            }
          }

        } else {
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        console.error("Error al crear el proyecto:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el proyecto',
        });
      }
    },
    async submitForm() {
      // Ya no se usa desde el modal, el guardado se hace con addDirectToDetail
    },

    async editRegister() {
      Swal.fire({
        icon: 'info',
        title: 'Editar detalle',
        text: 'Puede editar la cantidad directamente en la tabla de compras.',
        confirmButtonText: 'Aceptar'
      });
    },

    updateTotal() {
      const price = parseFloat(this.purchase.price) || 0;
      const quantity = parseFloat(this.purchase.quantity) || 0;
      const ivaRate = (parseFloat(this.purchase.iva) || 0) / 100;
      this.purchase.total_price = Math.floor(price * quantity * (1 + ivaRate));
    },
    async deleteRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("purchasesDetails/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getData();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    async getPayments() {
      if (!this.form.id || this.form.id === 0) return;
      try {
        const payments = await this.$store.dispatch('purchasePayments/getAll', { purchase_id: this.form.id });
        this.payments = payments || [];
      } catch (error) {
        console.error("Error al obtener pagos:", error);
        this.payments = [];
      }
    },
    openPaymentModal() {
      this.paymentForm = {
        id: 0,
        purchase_id: this.form.id,
        amount: 0,
        payment_method: '',
        payment_date: new Date().toISOString().split('T')[0],
        observation: '',
      };
      const modalElement = document.getElementById('ModalPayment');
      this.paymentModal = new Modal(modalElement);
      this.paymentModal.show();
    },
    closePaymentModal() {
      if (this.paymentModal) {
        this.paymentModal.hide();
      }
    },
    editPayment(payment) {
      this.paymentForm = {
        id: payment.id,
        purchase_id: payment.purchase_id,
        amount: payment.amount,
        payment_method: payment.payment_method || '',
        payment_date: payment.payment_date ? payment.payment_date.split('T')[0] : new Date().toISOString().split('T')[0],
        observation: payment.observation || '',
      };
      const modalElement = document.getElementById('ModalPayment');
      this.paymentModal = new Modal(modalElement);
      this.paymentModal.show();
    },
    async savePayment() {
      try {
        if (!this.paymentForm.amount || this.paymentForm.amount <= 0) {
          await Swal.fire({
            icon: 'warning',
            title: 'Campo requerido',
            text: 'Por favor ingrese un monto válido.',
            confirmButtonText: 'Aceptar'
          });
          return;
        }

        if (!this.paymentForm.payment_date) {
          await Swal.fire({
            icon: 'warning',
            title: 'Campo requerido',
            text: 'Por favor seleccione una fecha de pago.',
            confirmButtonText: 'Aceptar'
          });
          return;
        }

        const response = await this.$store.dispatch('purchasePayments/save', this.paymentForm);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El pago ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          });

          this.closePaymentModal();
          await this.getPayments();
        } else {
          throw new Error(response.data?.message || 'Error al guardar el pago');
        }
      } catch (error) {
        console.error("Error al guardar el pago:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al guardar el pago',
        });
      }
    },
    async deletePayment(id) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("purchasePayments/delete", id);
          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire(
              'Eliminado!',
              'El pago ha sido eliminado correctamente.',
              'success'
            );
            await this.getPayments();
          } else {
            throw new Error(response.data?.message || 'Error al eliminar el pago');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el pago:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al eliminar el pago',
        });
      }
    },
    formatCurrency(value) {
      return parseFloat(value || 0).toLocaleString('es-ES', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    formatDate(date) {
      if (!date) return '-';
      return new Date(date).toLocaleDateString('es-ES');
    },
    async getDocumentos() {
      if (!this.form.id || this.form.id === 0) return;
      try {
        const media = await this.$store.dispatch('media/getData', this.form.id);
        this.documentos = media.data.filter(item => item.mediaable_type === 'purchase');
      } catch (error) {
        console.error("Error al obtener documentos:", error);
        this.documentos = [];
      }
    },
    async saveDocumento() {
      const fileInput = document.getElementById("fileDocumento");
      if (!fileInput) return;
      
      try {
        const file = fileInput.files[0];

        if (!file) {
          return;
        }

        // Validar tipo de archivo
        const fileExtension = file.name.split('.').pop().toLowerCase();
        const validImageExtensions = ['jpeg', 'jpg', 'png', 'gif', 'svg'];
        const validPdfExtension = 'pdf';
        
        if (!validImageExtensions.includes(fileExtension) && fileExtension !== validPdfExtension) {
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Solo se permiten archivos de imagen (JPEG, PNG, JPG, GIF, SVG) o PDF.',
          });
          // Limpiar el input después del await
          this.$nextTick(() => {
            const input = document.getElementById("fileDocumento");
            if (input) input.value = '';
          });
          return;
        }

        const formData = new FormData();
        formData.append("mediaable_id", this.form.id);
        formData.append("mediaable_type", 'purchase');
        formData.append("file", file);

        const response = await this.$store.dispatch("media/save", formData);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El documento ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          });
          this.getDocumentos();
          // Limpiar el input después de guardar
          this.$nextTick(() => {
            const input = document.getElementById("fileDocumento");
            if (input) input.value = '';
          });
        } else {
          throw new Error(response.data?.message || 'Error al guardar el documento');
        }
      } catch (error) {
        console.error("Error al guardar el documento:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al guardar el documento',
        });
        // Limpiar el input en caso de error
        this.$nextTick(() => {
          const input = document.getElementById("fileDocumento");
          if (input) input.value = '';
        });
      }
    },
    async deleteMedia(id) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          await this.$store.dispatch("media/delete", id);
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El documento ha sido eliminado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          });
          this.getDocumentos();
        }
      } catch (error) {
        console.error("Error al eliminar el documento:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al eliminar el documento',
        });
      }
    },
    viewDocument(filePath) {
      const fileExtension = filePath.split('.').pop().toLowerCase();
      const isPdf = fileExtension === 'pdf';
      
      if (isPdf) {
        const pdfUrl = this.apiUrl + filePath;
        window.open(pdfUrl, '_blank');
      } else {
        const imageHtml = `<img src="${this.apiUrl + filePath}" alt="Documento" style="width: 100%; height: auto;" />`;
        Swal.fire({
          html: imageHtml,
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: 'Cerrar',
          backdrop: false,
          customClass: {
            popup: 'modal-dialog modal-dialog-centered',
          },
        });
      }
    },
    isImage(filePath) {
      if (!filePath) return false;
      const fileExtension = filePath.split('.').pop().toLowerCase();
      const validImageExtensions = ['jpeg', 'jpg', 'png', 'gif', 'svg'];
      return validImageExtensions.includes(fileExtension);
    },
    getFileIcon(filePath) {
      if (!filePath) return 'fa fa-file';
      const fileExtension = filePath.split('.').pop().toLowerCase();
      if (fileExtension === 'pdf') {
        return 'fa fa-file-pdf text-danger';
      } else {
        return 'fa fa-file-image text-primary';
      }
    },

  },
  async mounted() {

    this.user = JSON.parse(localStorage.getItem('user'));

    const route = useRoute();
    const dataEdit = route.params.data;

    this.getInsumos();

    // Cargar bodegas
    this.loadBodegas();

    // Cargar proveedores primero
    await this.getSuppluers();

    if (dataEdit) {
      try {
        const params = JSON.parse(dataEdit); // Asegúrate de que este JSON se pueda parsear

        this.data = params;
        if (params && params.id) {

          this.purchase.purchase_id = parseInt(params.id) || 0;

          this.form.id = parseInt(params.id) || 0;
          this.form.supplier = params.supplier || '';
          this.form.supplier_id = parseInt(params.supplier_id) || 0;
          this.form.phone = params.phone || '';
          this.form.email = params.email || '';
          this.form.status = parseInt(params.status) || 0;
          this.form.payment_type = params.payment_type || 'contado';
          this.form.payment_method = params.payment_method || '';
          this.form.due_date = params.due_date || null;
          this.form.description = params.description || '';

          await this.getData();
          await this.getPayments();
          await this.getDocumentos();

        
          // Actualizar Select2 con el valor del proveedor después de cargar los datos
          this.$nextTick(() => {
            if (this.$refs.supplierSelect && this.form.supplier_id > 0) {
              $(this.$refs.supplierSelect).val(this.form.supplier_id).trigger('change');
            }
          });
        }
      } catch (error) {
        console.error("Error al parsear los datos del registro:", error);
      }
    }

    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>

<style>
.disabled-link {
  color: gray;
  pointer-events: none;
  cursor: not-allowed;
}

.pur-product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 10px;
  max-height: 380px;
  overflow-y: auto;
  padding: 4px;
}

.pur-product-card {
  display: block;
  width: 100%;
  text-align: left;
  background: #fff;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  padding: 10px 12px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.pur-product-card:hover {
  border-color: #82d616;
  background: #f8fff4;
}

.pur-product-info h6 {
  font-weight: 600;
}

/* ---- Modal variantes (estilo POS) ---- */
.pur-variant-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.45);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pur-variant-box { width: 100%; max-width: 420px; border-radius: 12px; }
.pur-variant-list {
  display: flex;
  flex-direction: column;
  gap: .4rem;
  max-height: 340px;
  overflow-y: auto;
}
.pur-variant-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: .5rem;
  padding: .55rem .75rem;
  border: 1.5px solid #dee2e6;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  text-align: left;
  transition: border-color .15s, background .15s;
}
.pur-variant-btn:hover { border-color: #82d616; background: #f6fff0; }
.pur-variant-btn--selected { border-color: #82d616 !important; background: #f0ffe0 !important; }
.pur-variant-title { font-size: 13px; font-weight: 600; flex: 1; }
.pur-variant-meta  { font-size: 12px; white-space: nowrap; }
</style>
